:host .producer-content {
  font-family: 'Helvetica Now Text', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__header {
    font-size: 20px;
    font-weight: 800;
  }

  &__wrap {
    display: inline-block;
    position: relative;
    margin-right: 16px;
    width: 40px;
    height: 24px;

    &-icon {
      top: 0;
      position: absolute;
      width: 40px;
      height: 40px;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
}
